import React, { useRef, useState, useEffect } from "react";
import { Tag, Typography, Input, Button, Tabs } from "antd";
import { SearchOutlined, EyeInvisibleOutlined,EyeInvisibleFilled , CopyOutlined,EyeFilled} from "@ant-design/icons";
//import './Reports.scss';
import PrimaryNav from "../../shared/PrimaryNav";
import PageHeader from "../../shared/PageHeader";
import sampleHotel from "./sampleTeam.json";
import AgTableClient from "../../shared/AgTable/AgTableClient";
import './index.scss';
import { Segmented, Modal, Select, Form } from "antd";
import flipkartLogo from "../../assets/images/flipkart.jpg";
import { handleCellRenderer } from "app/shared/AgTable/AgUtility";



function HotelTeam() {
    const ref = useRef(null);
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    
    // Load data from localStorage on mount, or use sample data as fallback
    const [rowData, setRowData] = useState(() => {
        const savedData = localStorage.getItem('hotelTeamData');
        return savedData ? JSON.parse(savedData) : sampleHotel;
    });

    // Save to localStorage whenever rowData changes
    useEffect(() => {
        localStorage.setItem('hotelTeamData', JSON.stringify(rowData));
    }, [rowData]);

    const cardsData = [
        {
            hotels: 24,
            transactions: 118,
            gst: "₹20,54,465",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M5.83317 10.8333C6.25365 10.8332 6.65864 10.992 6.96696 11.2779C7.27528 11.5638 7.46413 11.9557 7.49567 12.375L7.49984 12.5V15C7.49997 15.4205 7.34117 15.8255 7.05526 16.1338C6.76935 16.4421 6.37747 16.631 5.95817 16.6625L5.83317 16.6667H3.33317C2.91269 16.6668 2.5077 16.508 2.19938 16.2221C1.89106 15.9362 1.70221 15.5443 1.67067 15.125L1.6665 15V12.5C1.66637 12.0795 1.82518 11.6745 2.11108 11.3662C2.39699 11.0579 2.78887 10.869 3.20817 10.8375L3.33317 10.8333H5.83317ZM13.3332 14.1667C13.5456 14.1669 13.7499 14.2482 13.9043 14.394C14.0588 14.5398 14.1517 14.7391 14.1641 14.9512C14.1766 15.1632 14.1076 15.372 13.9713 15.5349C13.835 15.6977 13.6416 15.8024 13.4307 15.8275L13.3332 15.8333H9.99984C9.78744 15.8331 9.58314 15.7518 9.4287 15.606C9.27425 15.4602 9.18131 15.2609 9.16886 15.0488C9.15641 14.8368 9.2254 14.628 9.36172 14.4651C9.49805 14.3023 9.69142 14.1976 9.90234 14.1725L9.99984 14.1667H13.3332ZM16.6665 10.8333C16.8875 10.8333 17.0995 10.9211 17.2558 11.0774C17.412 11.2337 17.4998 11.4457 17.4998 11.6667C17.4998 11.8877 17.412 12.0996 17.2558 12.2559C17.0995 12.4122 16.8875 12.5 16.6665 12.5H9.99984C9.77882 12.5 9.56686 12.4122 9.41058 12.2559C9.2543 12.0996 9.1665 11.8877 9.1665 11.6667C9.1665 11.4457 9.2543 11.2337 9.41058 11.0774C9.56686 10.9211 9.77882 10.8333 9.99984 10.8333H16.6665ZM5.83317 2.5C6.2752 2.5 6.69912 2.67559 7.01168 2.98816C7.32424 3.30072 7.49984 3.72464 7.49984 4.16667V6.66667C7.49984 7.10869 7.32424 7.53262 7.01168 7.84518C6.69912 8.15774 6.2752 8.33333 5.83317 8.33333H3.33317C2.89114 8.33333 2.46722 8.15774 2.15466 7.84518C1.8421 7.53262 1.6665 7.10869 1.6665 6.66667V4.16667C1.6665 3.72464 1.8421 3.30072 2.15466 2.98816C2.46722 2.67559 2.89114 2.5 3.33317 2.5H5.83317ZM13.3332 5.83333C13.5456 5.83357 13.7499 5.9149 13.9043 6.06071C14.0588 6.20651 14.1517 6.40579 14.1641 6.61783C14.1766 6.82986 14.1076 7.03865 13.9713 7.20153C13.835 7.3644 13.6416 7.46908 13.4307 7.49417L13.3332 7.5H9.99984C9.78744 7.49976 9.58314 7.41843 9.4287 7.27263C9.27425 7.12682 9.18131 6.92754 9.16886 6.7155C9.15641 6.50347 9.2254 6.29468 9.36172 6.13181C9.49805 5.96893 9.69142 5.86425 9.90234 5.83917L9.99984 5.83333H13.3332ZM16.6665 2.5C16.8789 2.50024 17.0832 2.58157 17.2376 2.72737C17.3921 2.87318 17.485 3.07246 17.4975 3.2845C17.5099 3.49653 17.4409 3.70532 17.3046 3.86819C17.1683 4.03107 16.9749 4.13575 16.764 4.16083L16.6665 4.16667H9.99984C9.78744 4.16643 9.58314 4.0851 9.4287 3.93929C9.27425 3.79349 9.18131 3.59421 9.16886 3.38217C9.15641 3.17014 9.2254 2.96135 9.36172 2.79847C9.49805 2.6356 9.69142 2.53092 9.90234 2.50583L9.99984 2.5H16.6665Z" fill="#046666" />
                </svg>
            )
        },
        {
            hotels: 18,
            transactions: 80,
            gst: "₹15,14,000",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M9.43657 1.02734V7.17127C9.43657 8.2427 9.93871 8.75342 11.0101 8.75342H17.0705V16.3538C17.0705 18.0948 16.2084 18.9738 14.4755 18.9738H5.58621C3.86157 18.9738 2.99121 18.1034 2.99121 16.3538V3.65556C2.99121 1.91449 3.86157 1.02734 5.58585 1.02734H9.43657ZM13.7809 10.637C13.7145 10.5706 13.6358 10.518 13.5491 10.4821C13.4624 10.4462 13.3695 10.4277 13.2757 10.4277C13.1818 10.4277 13.0889 10.4462 13.0023 10.4821C12.9156 10.518 12.8368 10.5706 12.7705 10.637L8.92871 14.4791L8.40014 14.9409L7.91871 14.4791L6.57657 13.1373C6.44185 13.0072 6.26142 12.9352 6.07414 12.9369C5.88686 12.9385 5.7077 13.0136 5.57527 13.146C5.44283 13.2785 5.36771 13.4576 5.36609 13.6449C5.36446 13.8322 5.43646 14.0126 5.56657 14.1473L7.91871 16.4995C8.05266 16.6334 8.23431 16.7086 8.42371 16.7086C8.61311 16.7086 8.79476 16.6334 8.92871 16.4995L13.7809 11.647C13.9148 11.513 13.99 11.3314 13.99 11.142C13.99 10.9526 13.9148 10.7709 13.7809 10.637ZM10.5748 1.11913C10.9266 1.17806 11.278 1.42092 11.663 1.8227L16.2837 6.51842C16.6769 6.92842 16.9194 7.26342 16.9784 7.60663H11.0355C10.7337 7.60663 10.5748 7.45592 10.5748 7.15449V1.11913Z" fill="#10B981" />
                </svg>
            )
        },
        {
            hotels: 6,
            transactions: 36,
            gst: "₹5,40,465",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 2V6.5C10 6.89782 10.158 7.27936 10.4393 7.56066C10.7206 7.84196 11.1022 8 11.5 8H16V16.5C16 16.8978 15.842 17.2794 15.5607 17.5607C15.2794 17.842 14.8978 18 14.5 18H9.743C10.4899 17.0956 10.928 15.976 10.9935 14.8049C11.059 13.6338 10.7483 12.4724 10.1069 11.4903C9.46551 10.5083 8.52694 9.75702 7.42827 9.34623C6.32959 8.93544 5.12837 8.88666 4 9.207V3.5C4 3.10218 4.15804 2.72064 4.43934 2.43934C4.72064 2.15804 5.10218 2 5.5 2H10ZM11 2.25V6.5C11 6.63261 11.0527 6.75979 11.1464 6.85355C11.2402 6.94732 11.3674 7 11.5 7H15.75L11 2.25ZM10 14.5C10 15.6935 9.52589 16.8381 8.68198 17.682C7.83807 18.5259 6.69347 19 5.5 19C4.30653 19 3.16193 18.5259 2.31802 17.682C1.47411 16.8381 1 15.6935 1 14.5C1 13.3065 1.47411 12.1619 2.31802 11.318C3.16193 10.4741 4.30653 10 5.5 10C6.69347 10 7.83807 10.4741 8.68198 11.318C9.52589 12.1619 10 13.3065 10 14.5ZM5.5 12C5.36739 12 5.24021 12.0527 5.14645 12.1464C5.05268 12.2402 5 12.3674 5 12.5V14.5C5 14.6326 5.05268 14.7598 5.14645 14.8536C5.24021 14.9473 5.36739 15 5.5 15C5.63261 15 5.75979 14.9473 5.85355 14.8536C5.94732 14.7598 6 14.6326 6 14.5V12.5C6 12.3674 5.94732 12.2402 5.85355 12.1464C5.75979 12.0527 5.63261 12 5.5 12ZM5.5 17.125C5.66576 17.125 5.82473 17.0592 5.94194 16.9419C6.05915 16.8247 6.125 16.6658 6.125 16.5C6.125 16.3342 6.05915 16.1753 5.94194 16.0581C5.82473 15.9408 5.66576 15.875 5.5 15.875C5.33424 15.875 5.17527 15.9408 5.05806 16.0581C4.94085 16.1753 4.875 16.3342 4.875 16.5C4.875 16.6658 4.94085 16.8247 5.05806 16.9419C5.17527 17.0592 5.33424 17.125 5.5 17.125Z" fill="#C00F0C" />
                </svg>
            )
        }
    ];

    const columnDefs = [
        {
            headerName: "Name",
            field: "Name",
        },
        {
            headerName: "Role",
            field: "Role",
        },
        {
            headerName: "Phone Number",
            field: "PhoneNumber",
            formatType: "CUSTOM_RENDER",
                      ...handleCellRenderer(),
                      formatProps: {
                        cellRenderer: (data, params) => {
                          return (
                            <Tag>{params?.PhoneNumber}</Tag>
                          );
                        },
                      },
        },
        {
            headerName: "Contact Email",
            field: "ContactEmail",
            formatType: "CUSTOM_RENDER",
                      ...handleCellRenderer(),
                      formatProps: {
                        cellRenderer: (data, params) => {
                          return (
                            <Tag>{params?.ContactEmail}</Tag>
                          );
                        },
                      },
        },
       {
  headerName: "Availability",
  field: "Availability",
  formatType: "CUSTOM_RENDER",
  ...handleCellRenderer(),
  formatProps: {
    cellRenderer: (data, params) => {
      const value = params?.Availability; // <-- FIX

      return (
        <Tag>
          {value === "Open" ? <EyeFilled  style={{ color: "#046666",marginRight: "4px"}} /> : <EyeInvisibleFilled  style={{ color: "#046666",marginRight: "4px"}} />}
          {value}
        </Tag>
      );
    },
  },
}


    ];


    return (
        <div
            style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <PageHeader
                style={{ height: '60px' }}
                leftActions={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                            <rect width="40" height="40" rx="4" fill="#8C734C" />
                            <path d="M29.9499 9.07643L30.9575 8.47134V5L27.0215 7.32484M30.5796 6.17834V8.34395L29.6665 6.71975L30.5796 6.17834ZM30.0443 8.66242L28.218 7.57962L29.1312 7.03822L30.0443 8.66242Z" fill="white" />
                            <path d="M29.6354 9.61818L26.707 7.89844V12.58L29.6354 10.8602M27.4942 8.822L29.3205 9.90481H27.4942V8.822ZM27.4942 11.6246V10.5417H29.3205L27.4942 11.6246Z" fill="white" />
                            <path d="M31.5879 11.9742V15.4456L35.5554 13.1207L32.627 11.3691M31.9972 14.2672V12.1016L32.9104 13.7258L31.9972 14.2672ZM33.4457 13.4074L32.5325 11.7832L34.3588 12.866L33.4457 13.4074Z" fill="white" />
                            <path d="M32.9414 9.61818V10.8284L35.8698 12.5481V7.89844M35.0511 11.6246L33.2248 10.5417H35.0511V11.6246ZM35.0511 9.90481H33.2248L35.0511 8.822V9.90481Z" fill="white" />
                            <path d="M35.5554 7.32484L31.5879 5V8.47134L32.5955 9.07643M31.9972 6.17834L32.9104 6.71975L31.9972 8.34395V6.17834ZM33.4457 7.03822L34.3588 7.57962L32.5325 8.66242L33.4457 7.03822Z" fill="white" />
                            <path d="M27.0215 13.1207L30.989 15.4456V11.9742L29.9499 11.3691M30.5796 14.2672L29.6665 13.7258L30.5796 12.1016V14.2672ZM29.1312 13.4074L28.218 12.866L30.0443 11.7832L29.1312 13.4074Z" fill="white" />
                            <path d="M9.19943 24.9683C9.19943 26.6244 9.19943 28.0575 9.10497 28.8218C9.04199 29.3314 8.94753 29.7454 8.56968 29.8091C8.41224 29.8409 8.19182 29.8728 7.93992 29.8728C7.7195 29.8728 7.65653 29.9365 7.65653 30.032C7.65653 30.1594 7.78248 30.2231 8.00289 30.2231C8.72712 30.2231 9.86068 30.1594 10.27 30.1594C10.7738 30.1594 11.9074 30.2231 13.1039 30.2231C13.2929 30.2231 13.4503 30.1594 13.4503 30.032C13.4503 29.9365 13.3558 29.8728 13.1669 29.8728C12.8835 29.8728 12.5057 29.8409 12.2538 29.8091C11.7185 29.7454 11.624 29.3314 11.561 28.8218C11.4666 28.0256 11.4666 26.6244 11.4666 24.9365V17.5161L13.7337 17.5798C15.3396 17.6116 15.8119 18.1212 15.8434 18.5989L15.8749 18.79C15.9064 19.0766 15.9378 19.1403 16.0638 19.1403C16.1583 19.1403 16.2212 19.0447 16.2212 18.8537C16.2212 18.3759 16.2842 17.1339 16.2842 16.7517C16.2842 16.4651 16.2527 16.3696 16.1268 16.3696C15.9693 16.3696 15.56 16.5607 14.3949 16.5607H7.27867C6.6804 16.5607 6.01916 16.5288 5.48386 16.4651C5.04303 16.4333 4.8541 16.2422 4.69666 16.2422C4.6022 16.2422 4.53923 16.3377 4.47625 16.5925C4.47625 16.7517 4.12988 18.4078 4.12988 18.6944C4.12988 18.8855 4.16137 18.981 4.28732 18.981C4.38179 18.981 4.44476 18.9173 4.47625 18.7581C4.50774 18.5989 4.6022 18.4078 4.79113 18.1212C5.07452 17.739 5.48386 17.6435 6.52296 17.6116L9.19943 17.5479" fill="white" />
                            <path d="M22.8032 25.5092L22.9607 25.6366L24.3776 29.4901C24.4721 29.713 24.3461 29.8722 24.2202 29.9041C24.0313 29.9359 23.9683 29.9678 23.9683 30.0633C23.9683 30.1907 24.1887 30.1907 24.5036 30.2225C25.9205 30.2544 27.18 30.2544 27.8098 30.2544C28.471 30.2544 28.6285 30.2225 28.6285 30.0633C28.6285 29.9359 28.534 29.9041 28.4081 29.9041C28.1877 29.9041 27.9358 29.8722 27.6838 29.8404C27.306 29.7448 26.8022 29.4901 26.1409 27.8659C25.0074 25.0951 22.205 17.7066 21.7956 16.6875C21.6067 16.2735 21.5122 16.1143 21.3548 16.1143C21.1659 16.1143 21.0714 16.3053 20.851 16.8467L16.4427 28.248C16.0963 29.1716 15.7499 29.7767 14.9627 29.8722C14.8368 29.9041 14.5849 29.9041 14.4274 29.9041C14.3015 29.9041 14.207 29.9359 14.207 30.0633C14.207 30.2225 14.3015 30.2544 14.5534 30.2544C15.4665 30.2544 16.4427 30.1907 16.6316 30.1907C17.1669 30.1907 17.9226 30.2544 18.4894 30.2544C18.6783 30.2544 18.7728 30.2225 18.7728 30.0633C18.7728 29.9678 18.7098 29.9041 18.5209 29.9041H18.269C17.7337 29.9041 17.5762 29.6811 17.5762 29.3308C17.5762 29.1079 17.6707 28.6939 17.8281 28.2162L18.7728 25.6047C18.8043 25.5092 18.8358 25.4455 18.9302 25.4455M19.2451 24.5856L19.1821 24.4582L20.788 19.9996L20.8825 19.8404L20.9769 19.9996L22.5513 24.4901L22.4569 24.5856H19.2451Z" fill="white" />
                            <path d="M30.4221 27.0701C30.4221 30.637 30.4536 32.4523 29.1311 33.8536C28.7847 34.2039 28.5328 34.4268 28.3124 34.5542C28.029 34.7134 27.9346 34.7771 27.9346 34.8727L28.0605 35.0319C28.155 35.0319 28.2809 35 28.4069 34.9364C28.7533 34.7453 29.0366 34.6179 29.2571 34.4586C30.8944 33.3758 31.8076 32.1338 32.1854 31.0192C32.5318 30 32.5948 28.8217 32.5948 27.8026C32.5948 26.9109 32.5318 26.0192 32.5318 25.2548V21.8472C32.5318 19.0765 32.5318 18.5669 32.5633 17.9937C32.5948 17.3567 32.7207 17.0383 33.193 16.9746C33.4135 16.9427 33.5079 16.9109 33.6969 16.9109C33.9173 16.9109 34.0117 16.879 34.0117 16.7516C34.0117 16.6243 33.8858 16.5924 33.6339 16.5924C32.9726 16.5924 31.8706 16.6561 31.4612 16.6561C31.0204 16.6561 29.9183 16.5924 29.0366 16.5924C28.7847 16.5924 28.6588 16.6243 28.6588 16.7516C28.6588 16.879 28.7533 16.9109 28.9422 16.9109C29.1941 16.9109 29.4775 16.9427 29.6034 16.9746C30.1702 17.102 30.2962 17.3886 30.3276 17.9937C30.3591 18.5669 30.3591 19.0765 30.3591 21.8472" fill="white" />
                        </svg>
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '4px' }}>
                            <span style={{ color: "#161922", fontSize: '16px' }}>Taj Hotel</span>
                            <span style={{ color: "#7D7D82", fontSize: '12px' }}>1245 Grand Avenue, Ojai, CA</span>
                        </div>
                    </div>
                }
            />
            <div className="header-section">
                <div className="header-content">
                    <Typography className="heading-text">Team</Typography>
                    <span className="subheading-text">Here’s what you need to focus on today</span>
                </div>
                <div className="my-segmented" style={{ display: "flex", gap: "8px" }}>
                    <Button
                        style={{
                            color: '#0a8394',
                            borderColor: "#0a8394",
                            backgroundColor: 'white'
                        }}
                        onClick={() => setOpen(true)}
                    >
                        Add Team Member
                    </Button>

                    <Button
                        style={{
                            color: 'white',
                            borderColor: "#0a8394",
                            backgroundColor: '#0a8394'
                        }}
                    >
                        Show All
                    </Button>
                </div>

            </div>



            {/* ag-Grid Table */}
            <div style={{ flex: 1, marginTop: "16px", marginLeft: "20px", marginRight: "20px" }}>
                <AgTableClient
                    columnDefs={columnDefs}
                    rowData={rowData}
                    ref={ref}
                    groupPanel
                />
            </div>

            <Modal
                open={open}
                onCancel={() => {
                    setOpen(false);
                    form.resetFields();
                }}
                footer={null}
                width={600}
                maskClosable={false}
                styles={{
                    header: {
                        background: '#0a8394',
                        padding: '16px 24px',
                        borderRadius: '8px 8px 0 0',
                        borderBottom: 'none',
                        margin: 0
                    },
                    body: {
                        padding: '24px'
                    },
                    content: {
                        padding: 0
                    }
                }}
                title={
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        color: 'white',
                        width: '100%',
                        margin: 0,
                        padding: 0
                    }}>
                        <span style={{ color: 'white', fontSize: '18px', fontWeight: 600 }}>Add Team Member</span>
                        <span 
                            onClick={() => {
                                setOpen(false);
                                form.resetFields();
                            }}
                            style={{ 
                                color: 'white', 
                                cursor: 'pointer', 
                                fontSize: '20px',
                                lineHeight: '1'
                            }}
                        >
                            ×
                        </span>
                    </div>
                }
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={(values) => {
                        console.log('Form values:', values);
                        // Create new team member object matching the table structure
                        const newMember = {
                            Name: values.name,
                            Role: values.role,
                            PhoneNumber: values.phoneNumber,
                            ContactEmail: values.email,
                            Availability: values.status // status is "Open" or "Hidden"
                        };
                        
                        // Add new member to the table data
                        setRowData([...rowData, newMember]);
                        
                        // Close modal and reset form
                        setOpen(false);
                        form.resetFields();
                    }}
                >
                    <Form.Item
                        label={<span>Name <span style={{ color: 'red', marginLeft: '4px' }}>*</span></span>}
                        name="name"
                        required={false}
                        rules={[{ required: true, message: 'Please enter full name' }]}
                    >
                        <Input 
                           style={{marginBottom: '16px'}}
                            placeholder="Enter full name"
                        />
                    </Form.Item>

                    <Form.Item
                        label={<span>Role <span style={{ color: 'red', marginLeft: '4px' }}>*</span></span>}
                        name="role"
                        required={false}
                        rules={[{ required: true, message: 'Please enter role/position' }]}
                    >
                        <Input 
                         style={{marginBottom: '16px'}}
                            placeholder="Enter role/position"
                        />
                    </Form.Item>

                    <Form.Item
                        label={<span>Phone Number <span style={{ color: 'red', marginLeft: '4px' }}>*</span></span>}
                        name="phoneNumber"
                        required={false}
                        rules={[
                            { required: true, message: 'Please enter phone number' },
                            { pattern: /^\d{10}$/, message: 'Please enter a valid 10-digit phone number' }
                        ]}
                    >
                        <Input 
                         style={{marginBottom: '16px'}}
                            placeholder="Enter 10-digit phone number"
                        />
                    </Form.Item>

                    <Form.Item
                        label={<span>Email <span style={{ color: 'red', marginLeft: '4px' }}>*</span></span>}
                        name="email"
                        required={false}
                        rules={[
                            { required: true, message: 'Please enter email address' },
                            { type: 'email', message: 'Please enter a valid email address' }
                        ]}
                    >
                        <Input 
                         style={{marginBottom: '16px'}}
                            placeholder="Enter email address"
                        />
                    </Form.Item>

                    <Form.Item
                        label={<span>Status <span style={{ color: 'red', marginLeft: '4px' }}>*</span></span>}
                        name="status"
                        required={false}
                        rules={[{ required: true, message: 'Please choose status' }]}
                    >
                        <Select
                            placeholder="Choose status"
                            style={{ width: '100%' }}
                        >
                            <Select.Option value="Open">Open</Select.Option>
                            <Select.Option value="Hidden">Hidden</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0, marginTop: '24px' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <Button
                                onClick={() => {
                                    setOpen(false);
                                    form.resetFields();
                                }}
                                style={{
                                    background: 'white',
                                    color: '#161922',
                                    borderColor: '#E1E6EA'
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    background: '#0a8394',
                                    borderColor: '#0a8394'
                                }}
                            >
                                Add Member
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>

        </div>
    );
}

export default HotelTeam;

